<template>
  <div class="lc-page">
    <div class="container">
      <div class="title_holder">
        <h3>{{$t("nav.licenses_and_certificates")}}</h3>
        <div class="breadcrumbs">
          <ul>
            <li class="item-home">
              <router-link class="bread-link bread-home" to="/" title="Home"
                >{{$t("nav.main")}}</router-link
              >
            </li>
            <li class="separator separator-home">
              <span></span>
            </li>
            <li class="item-current">
              <span class="bread-current">{{$t("nav.licenses_and_certificates")}}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="lc-list">
        <div class="row">
          <VueGallery
            :images="imageTarget"
            :index="index"
            @close="index = null"
          ></VueGallery>
          <div
            class="col-md-3 as-gallery"
            v-for="(img, index) in lImages"
            :key="img"
            @click="ChangeImage(index, img)"
          >
            <div class="img_holder">
              <img :src="require('../assets/images/licenses/' + img)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueGallery from "vue-gallery";
export default {
  data() {
    return {
      index: null,
      imageTarget: [],
      lImages: [
        "3.jpg",
        "4.jpg",
        "5.jpg",
        "6.jpg",
        "7.jpg",
        "8.jpg",
        "9.jpg",
        "10.jpg",
        "11.jpg",
        "12.jpg",
        "13.jpg",
        "14.jpg",
        "15.jpg",
        "16.jpg",
        "17.jpg",
        "18.jpg",
        "19.jpg",
        "20.jpg",
        "21.jpg",
        "22.jpg"
      ]
    };
  },
  methods: {
    ChangeImage: function(index, item) {
      this.index = index;
      for (var i = 0; i < this.lImages.length; i++) {
        this.imageTarget.push(
          require("../assets/images/licenses/" + this.lImages[i])
        );
      }
    }
  },
  components: {
    VueGallery
  }
};
</script>

<style>
.lc-page {
  margin-bottom: 60px;
}
.lc-page .title_holder {
  position: relative;
  padding: 95px 0 35px;
  width: 100%;
  float: left;
  clear: both;
}
.lc-page .title_holder .breadcrumbs {
  width: 100%;
  float: left;
  clear: both;
  position: relative;
  padding-top: 13px;
  padding-bottom: 2px;
}
.lc-page .title_holder .breadcrumbs ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.lc-page .title_holder .breadcrumbs li {
  float: left;
  margin-bottom: 5px;
}
.lc-page .title_holder .breadcrumbs li a {
  font-size: 14px;
  color: #666;
  text-decoration: none;
  letter-spacing: 0;
  line-height: 1.5;
  font-weight: 600;
}
.lc-page .title_holder .breadcrumbs .separator span {
  width: 33px;
  height: 24px;
  display: block;
  position: relative;
}
.lc-page .title_holder .breadcrumbs .separator span:after,
.lc-page .title_holder .breadcrumbs .separator span:before {
  width: 9px;
  height: 2px;
  display: block;
  position: absolute;
  background-color: #ddd;
  left: 13px;
  content: "";
}
.lc-page .title_holder .breadcrumbs .separator span:before {
  top: 14px;
  transform: rotate(135deg);
}
.lc-page .title_holder .breadcrumbs .separator span:after {
  top: 8px;
  transform: rotate(45deg);
}
.lc-page .img_holder {
  position: relative;
  background: rgba(0, 0, 0, 0.5);
  border: 6px solid rgba(255, 255, 255, 0.75);
  margin-right: 5px;
  overflow: hidden;
  margin-bottom: 30px;
}
.lc-page .img_holder img {
  opacity: 0.5;
  height: auto;
  width: 100%;
}
</style>
